import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './Spinner.scss';
/**
 * @component Spinner
 * @since 1.0.0
 */
export function Spinner(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const className = classNames('spinner', 'spinner--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "spinner-indicator" })));
}
